module.exports = __webpack_public_path__ + "static/media/CERTIFICATE-SEKOLAH-BULANAN-3.c1ef1dd8.png";